import { render, staticRenderFns } from "./ManagePersonTypeListView.vue?vue&type=template&id=7c894124"
import script from "./ManagePersonTypeListView.vue?vue&type=script&lang=ts"
export * from "./ManagePersonTypeListView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports